/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, NgZone, OnInit } from '@angular/core';
import { Participant } from '../../shared/model/Participant';
import { MemberService } from '../../shared/services/member.service';
import { MODULE_NAME_CODES } from '../../config/constants';
import { CommonService } from '../../shared/services/common.service';
import { LoginService } from '../../components/login/login.service';
import { TranslateService } from '@ngx-translate/core';
import { HomeSearchFilterPipe } from '../../shared/pipes/HomeSearchFilterPipe';
import { Router } from '@angular/router';
import * as _ from 'underscore';
import { MarketService } from 'app/shared/services/market.service';
import { HomeService } from './home.service';

@Component({
  selector: 'home-comp',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [MemberService, HomeSearchFilterPipe]
})

export class HomeComponent implements OnInit {

  public memberObj: Participant = new Participant();
  public membersList: Participant[] = [];
  public isNewMemberCreated = false;
  public userName: any;
  public userGroups: any;
  public user: any = {};
  public globalFilterValue = '';
  public bookmarkCard: any;
  public rvcCard: any;
  public menuObj: any = {};
  public timeZoneInfo: any;

  constructor(
    private marketService: MarketService,
    private memberService: MemberService,
    private translate: TranslateService,
    private commonService: CommonService,
    private homeService: HomeService,
	  private router: Router,
	  private zone: NgZone,
    private loginService: LoginService) {
	this.getUserDetails();
    setTimeout(() => {
        this.bookmarkCard = {
          code: 'BSC',
          name: this.getTrnslation('bookmarks'),
          icon: 'icon-favorite-list',
          showCloseIcon: false,
          showSearchBox: false,
          filter: this.getTrnslation('bookmarks_filter'),
          filterVal: '',
          recentSort: true,
          cardFrom: 'HMP',
          noDataMsg: this.getTrnslation('no_bookmarks_message')+ `<em class='icon-favorite-list' style='color:#2797df;'></em>`+ this.getTrnslation('icon_share'),
          draggable: false,
          items: [{
            name: this.getTrnslation('salesforce'),
            code: MODULE_NAME_CODES.Distributors,
            collapse: false,
            list: []
          }, {
            name: this.getTrnslation('lineage'),
            code: MODULE_NAME_CODES.Genealogies,
            collapse: false,
            list: []
          }, {
            name: this.getTrnslation('reports'),
            code: MODULE_NAME_CODES.Reports,
            collapse: false,
            list: []
          }, {
            name: this.getTrnslation('shared_with_me'),
            collapse: false,
            list: []
          }]
        };
        this.rvcCard = {
          code: 'RVC',
          name: this.getTrnslation('recently_viewed'),
          icon: 'icon-history',
          showCloseIcon: false,
          showSearchBox: false,
          filter: this.getTrnslation('recently_viewed_filter'),
          filterVal: '',
          recentSort: true,
          cardFrom: 'HMP',
          noDataMsg: this.getTrnslation('no_recently_viewed_data_message'),
          draggable: false,
          items: [{
            name: this.getTrnslation('salesforce'),
            code: MODULE_NAME_CODES.Distributors,
            collapse: false,
            list: []
          }, {
            name: this.getTrnslation('lineage'),
            code: MODULE_NAME_CODES.Genealogies,
            collapse: false,
            list: []
          }, {
            name: this.getTrnslation('reports'),
            code: MODULE_NAME_CODES.Reports,
            collapse: false,
            list: []
          }]
        }

      const menuId = this.commonService.getMenuId('HOM');
        this.commonService.setHelpObj({
          header: this.getTrnslation('HOM') || '',
          menuId: menuId,
          sections: [],
          lastSavedData: [],
          tools: [
            {
              icon: 'icon-favorite',
              action: this.getTrnslation('bookmarks_favorite'),
              actionInfo: this.getTrnslation('bookmark_info')
            }, {
              icon: 'icon-edit',
              action: this.getTrnslation('edit'),
              actionInfo: this.getTrnslation('edit_info')
            }, {
              icon: 'icon-share-2',
              action: this.getTrnslation('share'),
              actionInfo: this.getTrnslation('share_info')
            }, {
              icon: 'icon-delete',
              action: this.getTrnslation('delete'),
              actionInfo: this.getTrnslation('delete_info')
            }
          ],
          relatedLinks: [
            {
              label: this.getTrnslation('FLP'),
              url: '/fieldsupport/distributorList/default'
            }, {
              label: this.getTrnslation('GLY'),
              url: '/genealogyHome/genealogy/default'
            }, {
              label: this.getTrnslation('ALT'),
              url: '/compensationHome/compensationAnalytics/default'
            }
          ]
        });
    }, 1000);
    // this.getHomeMetaDetails();
  }

  ngOnInit() {
    this.getUserDetails();
    this.getGlobalSettings(null);
    // MLM-2777
    this.commonService.getGenealogyConfig()
      .then(this.getGenealogyConfigSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    // // get Home Meta Data
    // this.homeMetaData = this.commonService.getHomeMetaDetails();
    this.getAllMarkets();
  }

  public getTrnslation(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }


  public getGlobalSettings(payload: any) {
      this.commonService.getGlobalSettingstabType(payload)
        .then(this.getGlobalSettingsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  public getGlobalSettingsSH(res: any) {
    let dtObj, dateFormatObj;
    const dateObj = res.filter(function (resObj: any) {
      return (resObj.code == "DTFMT");
    });
    if (dateObj.length) {
      if (dateObj[0].value.split("/").length) {
        dtObj = dateObj[0].value.split("/");
      } else if (dateObj[0].value.split("-").length) {
        dtObj = dateObj[0].value.split("-");
      }
      const dateFormatArr = dtObj, cDateFormatArr: any = [];
      dateFormatArr.forEach(function (dtf: any) {
        cDateFormatArr.push(dtf.toUpperCase());
      });
      if (dateObj[0].value.split("/").length) {
        dateFormatObj = cDateFormatArr.join("/");
      } else {
        dateFormatObj = cDateFormatArr.join("-");
      }
      this.commonService.setDateFormat(dateFormatObj);
    }
    this.getHomeMetaDetails();
    this.getApplicationVersion();
    const companyCode = this.commonService.getCompanyCode();
      if (companyCode) {
        this.homeService.getCalendarDefinitionTabType(companyCode)
          .then(this.getCalendarDefinitionSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
      }
    // try {
    //   const localeCode = res.find((x: any) => x.code === 'CF').value;
    //   const localeCurrency = res.find((x: any) => x.code === 'CC').value;
    //   this.commonService.setLocale(localeCode, localeCurrency);
    // } catch(e) {
    // }
  }

  public getAllMarkets() {
    this.homeService
      .getAllMarkets()
      .then(this.getAllMarketsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  private getAllMarketsSH(data: any) {
    for (const market of data) {
      const eachMarket = market,
        regions = eachMarket.regions || [];
      if (regions.length) {
        for (const region of regions) {
          try {
            const localeCode = region.currencyFormat;
            const localeCurrency = region.currency;
            this.commonService.setLocale(localeCode, localeCurrency);
          } catch (e) {
          }
        }
      }
    }
  }

  private getCalendarDefinitionSH(res: any) {
    if (res) {
      this.timeZoneInfo = res.timeZone || 'America/Los_Angeles';
      this.commonService.setTimeZonInfo(this.timeZoneInfo);
    }
  }

  public getApplicationVersion() {
    this.loginService.getAppVersion().then((res: any) => {
      this.commonService.setAppVersion(res && res.appVersion);
    }, (err: any) => {})
  }

  private getGenealogyConfigSH(data: any) {
    const response = data;
    if (response) {
      const result = response;
      this.commonService.setGenealogyConfiguration(result.leadershipFunction);
      this.commonService.setCompanyConfiguration(result);
    } else {
      this.commonService.setGenealogyConfiguration({ name: '' });
    }
  }

  // ngAfterViewInit(){
  //     // setTimeout(function(){
  //     //     this.homeService.homeMetaData.emit();
  //     // }.bind(this), 300);  
  // }

  // public navigateToProfilePage() {
  //   this.router.navigateByUrl('/profile/id');
  // }

  private getUserDetails() {
    let userInfo: any = {};
    userInfo = this.commonService.getUserDetails();
    if (!userInfo) {
      this.loginService.getUserProfileDetails()
        .then(this.getUserDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    } else {
      userInfo = JSON.parse(JSON.stringify(this.commonService.getUserDetails()));
      this.getUserDetailsSH(userInfo);
    }
  }


  private getUserDetailsSH(response: any) {
    const responseMsg = response;
    if (responseMsg) {
      this.loginService.setUser(responseMsg);
      this.commonService.setUserDetails(responseMsg);
      this.user = responseMsg;
      this.userName = this.prepareUserName(this.user);
      this.userGroups = this.prepareUserGroups(this.user);
	    let langCode = 'en_us';
      this.commonService.setUserDetails(responseMsg);
      this.loginService.setUser(responseMsg);
	        this.loginService.setTimeZoneBasedOnCalendarDefination();     
	        if (responseMsg.language && responseMsg.language.locale) {
	          langCode = responseMsg.language.locale;
	          if (langCode) {                     
	            this.commonService.getTranslationsOfSelectedLanguage(langCode).then((res: any) => {            
	              this.commonService.setTranslatedObj(res);
	            }, (err) => {
	              this.commonService.commonErrorHandler(err);
	              this.commonService.setTranslatedObj([]);
	            });
	          }
	        }
	        localStorage.setItem('userLanguage', langCode);
	        this.commonService.loadTranslations();
	        if (responseMsg.permissions && responseMsg.permissions.features) {
	          this.formatFeaturePermissions(responseMsg.permissions.features);
	        }
	        if (responseMsg.permissions && responseMsg.permissions.menus) {
	          this.prepareMenuObj(responseMsg.permissions.menus);
	        }
	        this.getHomePageMetaData();
          this.getGlobalMetadata();
    }
  }
  
  private getHomeMetaDetails() {
    this.commonService.getHomeMetaAPIData()
      .then(this.getHomeMetaDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  private getHomeMetaDetailsSH(response: any) {
    const responseMsg = response;
    if (responseMsg) {
      this.commonService.setHomeMetaDetails(responseMsg);
    }
  }

  private getGlobalMetadata() {
    this.commonService.fetchGlobalMetaData()
      .then((response) => {
        const res: any = response;
        res.metricsMetaData = JSON.parse(JSON.stringify(_.sortBy(res.metricsMetaData || [], 'name')));
        localStorage.setItem('globalMetaData', JSON.stringify(res))
      }, (reason) => this.commonService.commonErrorHandler(reason));
  }

  private formatFeaturePermissions(features: any) {
    localStorage.setItem('featuresAvailable', '');
    const featuresAvailable: any = {};
    features.forEach((element: any, index: any) => {
      featuresAvailable[element.code] = true;
    });
    localStorage.setItem('featuresAvailable', JSON.stringify(featuresAvailable));
  }
  
  private prepareMenuObj(menus: any) {
    localStorage.setItem('MenuIds', '');
    const menuIds: any = {};
    menus.forEach((element: any) => {
      menuIds[element.code] = element.id;
    });
    localStorage.setItem('menuIds', JSON.stringify(menuIds));
  }

  private getHomePageMetaData() {
    this.loginService.getHomePageMetaData()
      .then(this.getHomePageMetaDataSH.bind(this), this.getHomePageMetaDataFH.bind(this));
  }

  private getHomePageMetaDataSH(response: any) {
    const res = response;
    this.loginService.setHomePages(res);
    const user = this.loginService.getUser();
    if (user) {
      const groups = user.groups,
        group = groups.length ? groups[0] : '';
        if (group) {
          const lastUnauthorizedUrl = localStorage.getItem('unAuthorizedURL');
          if (lastUnauthorizedUrl && lastUnauthorizedUrl != 'null') {
            localStorage.removeItem('unAuthorizedURL');
          }
        }
    }
  }

  private getHomePageMetaDataFH(error: any) {
    this.loginService.setHomePages([]);
  }

  private prepareUserName(user: any) {
    const names = [],
      firstName = user ? (user.firstName ? user.firstName : '') : '';
    if (firstName) {
      names.push(firstName);
    }
    const lastName = user ? (user.lastName ? user.lastName : '') : '';
    if (lastName) {
      names.push(lastName);
    }
    return names.join(' ');
  }

  private prepareUserGroups(user: any) {
    const groups = [];
    if (user.groups && user.groups.length) {
      for (const grp of user.groups) {
        groups.push(grp.name);
      }
    }
    return groups.join(', ');
  }

  public displayList(item: any, state: any) {
    item.collapse = !state;
  }

  public createMember() {
    this.memberService.createMember(this.memberObj)
      .then(this.createMemberSuccessHandler.bind(this),
        this.createMemberFailureHandler.bind(this));
  }

  private getAllMembers() {
    this.memberService.getAllMembers()
      .then(this.getMembersSuccessHandler.bind(this),
        this.getMembersFailureHandler.bind(this));
  }

  private createMemberSuccessHandler(data: any) {
    this.isNewMemberCreated = true;
    this.memberObj = new Participant();
    this.getAllMembers();
  }

  private createMemberFailureHandler(err: Error) {
    console.error('Error at CreateMember: ', err);
  }

  private getMembersSuccessHandler(data: any) {
    this.membersList = data;
  }

  private getMembersFailureHandler(err: Error) {
    console.error('Error While Fetching Members List: ', err);
  }
}